<template>
  <base-layout toolbarActive>
    <template #toolbarBase>
      <div class="display-2 font-weight-bold text-xs--center">Профиль</div>
    </template>

    <v-layout column fill-height justify-space-between>
      <user-profile class="px-4"></user-profile>

      <v-layout align-center justify-space-between class="px-4">
        <label for="themeDark" class="font-weight-medium">
          <span v-if="!themeDark">
            <icon-moon class="mr-2"></icon-moon> <span>Темная тема</span>
          </span>
          <span v-if="themeDark">
            <icon-sun class="mr-2"></icon-sun> <span>Светлая тема</span>
          </span>
        </label>
        <v-switch
          v-model="themeDark"
          id="themeDark"
          class="mt-0 flex-none"
          hide-details
        >
        </v-switch>
      </v-layout>
    </v-layout>
  </base-layout>
</template>

<script>
import BaseLayout from "../components/layout/BaseLayout.vue";
import UserProfile from "../components/user/UserProfile.vue";
import IconMoon from "../components/icon/IconMoon.vue";
import IconSun from "../components/icon/IconSun.vue";

export default {
  name: "UserProfileView",

  components: {
    IconSun,
    IconMoon,
    UserProfile,
    BaseLayout
  },

  data: () => ({}),

  mounted() {},

  computed: {
    // цветовая тема проекта
    themeDark: {
      get: function() {
        return this.$store.getters.themeDark;
      },
      set: function(value) {
        this.$store.commit("SET_THEME_DARK", value);
      }
    }
  }
};
</script>
